const t = /* @__PURE__ */ new Map();
async function a(n) {
  const c = n.map((s) => {
    if (t.has(s))
      return t.get(s);
    const e = s();
    return t.set(s, e), e;
  });
  await Promise.all(c);
}
export {
  t as _cache,
  a as promiseAllCached
};
//# sourceMappingURL=index.js.map
